<section *ngIf="! disabled && filteredMenuItems.length > 0"
         class="drop-down-menu-section"
         genPermissionSchemaRestrict [permissionSchemaKey]="permissionId"
                                     [nonePermissionAction]="getNoPermissionAction()"
                                     [forcePermission]="isForcePermission(permissionId)"
         (clickOutside)="showMenuItems(false)">

  <span class="{{menuClassName}} icon"
        genTooltip [tooltipHtml]="tooltipHtml" [tooltipPosition]="tooltipPosition" [appendToBody]="true" [tooltipShow]="true"
        (click)="runTopMenuAction()">

      <span class="path1"></span>
      <span class="path2"></span>
      <span class="path3"></span>
  </span>

  <section class="drop-down-menu-options card-layout" *ngIf="menuItemsVisibility">

    <div *ngFor="let menuItem of filteredMenuItems; trackBy:(menuItem?.label)"
         class="clearfix">

      <span class="single-menu-item"
            (click)="runMenuItemAction(menuItem)">

        <i class="{{menuItem.icon}} single-menu-item-icon"></i>

        {{menuItem.label}}
      </span>

    </div>

  </section>
</section>